import { View } from "./View";

import { useEffect, useState } from "react";
import { toPng } from "html-to-image";
import download from "downloadjs";

import { IViewSingleTransfer } from "../../../../interfaces-and-types";
import { useNavigate, useParams } from "react-router-dom";
import { useMerchantApiQueryWithParams } from "../../../../hooks";

type TReceiptType = "png" | "pdf";

export interface ITransferReceiptModalViewProps {
  isLoading: boolean;
  isError: boolean;
  transfer: IViewSingleTransfer | null;
  isModalOpen: boolean;
  isHtmlReceiptHidden: boolean;
  receiptImageElement: HTMLImageElement | null;
  receiptImageRenderingComplete: boolean;
  closeModal: () => void;
  downloadReceiptImage: (receiptType: TReceiptType) => void;
}

export const TransferReceiptModal = () => {
  const navigate = useNavigate();

  const closeModal = () => {
    navigate(-1);
  };

  const { id } = useParams();

  const {
    isLoading: isLoadingSingleTransfer,
    isSuccess: isSuccessSingleTransfer,
    isError: isErrorSingleTransfer,
    data: transfer,
  } = useMerchantApiQueryWithParams<{ id: string }, IViewSingleTransfer>(
    [
      "getSingleTransferById",
      {
        id: id!,
      },
    ],
    {
      enabled: !!id,
    },
    (urlTemplate) => urlTemplate.replace("id", id!)
  );

  const [receiptImageElement, setReceiptImageElement] =
    useState<HTMLImageElement | null>(null);

  const [receiptImageRenderingComplete, setReceiptImageRenderingComplete] =
    useState(false);

  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);

  const [isHtmlReceiptHidden, setIsHtmlReceiptHidden] = useState(false);

  useEffect(() => {
    if (isSuccessSingleTransfer && !receiptImageElement) {
      var nodeElement = document.getElementById("transfer-receipt");

      if (!nodeElement) return;

      toPng(nodeElement, {
        /*width: 540, height: 540*/
      })
        .then(function (dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          img.alt = "transfer receipt";
          img.id = "transfer-receipt-image";

          setReceiptImageElement(img);
          setReceiptImageRenderingComplete(true);

          setTimeout(() => setIsHtmlReceiptHidden(true), 800);

          setDownloadUrl(dataUrl);
        })
        .catch(function (error) {
          console.error(
            "oops, something went wrong! Could not retrieve transfer receipt",
            error
          );
        });
    }
  }, [isSuccessSingleTransfer]);

  const downloadOrShareReceiptImage = (receiptType: TReceiptType) => {
    if (!downloadUrl) return;

    if (receiptType === "png") {
      download(downloadUrl, `Transfer Receipt ${transfer!.reference}.png`);
      return;
    }

    // if (receiptType === "pdf") {
    //   download(downloadUrl, `Transfer Receipt ${transfer!.reference}.pdf`);
    //   return;
    // }

    throw new Error("The receipt type is not supported");
  };

  return (
    <View
      isLoading={isLoadingSingleTransfer}
      isError={isErrorSingleTransfer}
      transfer={transfer || null}
      isHtmlReceiptHidden={isHtmlReceiptHidden}
      receiptImageElement={receiptImageElement}
      receiptImageRenderingComplete={receiptImageRenderingComplete}
      isModalOpen={!!id}
      closeModal={closeModal}
      downloadReceiptImage={downloadOrShareReceiptImage}
    />
  );
};
